@use "@styles/variables";

@layer base-components {
    .errorToast {
        width: 100%;
        min-width: 0;
    }

    .messageRow,
    .traceIdRow {
        width: 100%;
        min-width: 0;
    }

    .icon {
        flex-shrink: 0;
        width: variables.rem(16px);
        height: variables.rem(16px);
        margin: variables.rem(2px);
        stroke: variables.$gray-700;
    }

    .iconSpacer {
        flex-shrink: 0;
        width: variables.rem(20px);
        height: variables.rem(20px);
    }

    .message {
        flex: 1;
        min-width: 0;
        padding-right: variables.rem(20px);
        font-size: variables.rem(14px);
        line-height: variables.rem(20px);
        letter-spacing: -0.07px;
        color: variables.$gray-900;
        overflow-wrap: anywhere;
    }

    .traceId {
        flex: 1;
        min-width: 0;
        font-size: variables.rem(10px);
        line-height: variables.rem(16px);
        color: variables.$gray-500;
        overflow-wrap: anywhere;
    }

    .actions {
        width: 100%;
    }
}
